// Sessões/dispositivos conectados de um usuário (GPS Drive Backend) — aba
// DISPOSITIVOS CONECTADOS em Editar Usuário. Reflete refresh_tokens ativos
// (não revogados, não expirados) — desconectar aqui revoga o refresh
// token de verdade: a próxima renovação silenciosa daquele navegador/
// aparelho falha e ele é deslogado (o access token já emitido no
// navegador continua válido até expirar naturalmente, não é instantâneo).
import { gpsDriveDelete, gpsDriveGet } from "@/lib/api/gpsdrive-client";

export interface UserSession {
  id: string;
  userAgent: string | null;
  createdAt: string;
  expiresAt: string;
}

export const gpsDriveUserSessionsService = {
  list: (userId: string) => gpsDriveGet<UserSession[]>(`/api/v1/users/${userId}/sessions`),
  revoke: (userId: string, sessionId: string) =>
    gpsDriveDelete<void>(`/api/v1/users/${userId}/sessions/${sessionId}`),
};
